import type { InventoryProblem } from '@/lib/api/schemas/inventory.schema'
import { SectionCard } from '@/components/warehouse/primitives'

interface Props {
  problems: readonly InventoryProblem[]
  available: boolean
  unavailableReason: string | null
}

/** The card and quick preview share one conditional, server-labelled box. */
export function ProductProblems({ problems, available, unavailableReason }: Props) {
  if (problems.length === 0) {
    return available ? null : (
      <p data-problems-unavailable="true" className="text-xs text-ink-muted">
        {unavailableReason ?? 'Проверка проблем недоступна.'}
      </p>
    )
  }
  return <SectionCard title="Проблемы" ariaLabel="Проблемы изделия">
    <ul data-problems-box="true" className="space-y-2 text-xs text-ink-2">
      {problems.map((problem, index) => <li key={`${problem.code}-${problem.position ?? index}`}>
        <span className="font-medium">{problem.label}</span>
        {problem.detail ? <span className="mt-0.5 block text-ink-muted">{problem.detail}</span> : null}
      </li>)}
    </ul>
    {!available ? <p className="mt-2 text-xs text-ink-muted">Часть проверки недоступна.</p> : null}
  </SectionCard>
}
